import { GridBaseDataProvider } from '../../../../grid/GridBaseDataProvider';
import { DEFAULT_PAGE_SIZE, LiveSearchResultsGridGetRowsResponse } from '../types';
import { QueryExecution, Result } from '../../types';
import {
  GetRowsRequest,
  GetSummaryRequest,
  GetSummaryResponse,
  SetFiltersRequest,
  UpdateSettingsRequest,
  UpdateSettingsResponse,
} from '../../../../grid/types/common';
import { sanitizeObject } from '../../../../utils/sanitization.utils';
import { getRequestDefaultOptions } from '../../../../utils/request.utils';

export class LiveSearchResultsGridDataProvider extends GridBaseDataProvider<any, any> {
  private pageSize: number = DEFAULT_PAGE_SIZE;
  private response: any;

  constructor(public dependencies: any, private queryExecution: QueryExecution | null) {
    super();
  }

  public async getSummary(request: GetSummaryRequest<any>): Promise<GetSummaryResponse> {
    let numItems = 0;

    if (this.queryExecution && this.queryExecution._id) {
      this.response = await this.request(request);

      numItems = this.response.total;
    }

    return sanitizeObject({
      summary: this.dependencies.translateFn('{itemsCount} items', { itemsCount: numItems }),
      numItems,
    });
  }

  public async getRows(request: GetRowsRequest<any, any>): Promise<LiveSearchResultsGridGetRowsResponse> {
    if (!this.queryExecution || !this.queryExecution._id) {
      return { rawEvents: [] };
    }

    const response = this.response ?? (await this.request(request)),
      data = response.success
        ? response.data.map((result: Result): any =>
            Object.assign(
              {
                endpoint: result.endpoint.name,
                endpointId: result.endpoint.id,
              },
              result.data
            )
          )
        : [];
    return sanitizeObject({ rawEvents: data });
  }

  public async updateSettings(params: UpdateSettingsRequest<any>): Promise<UpdateSettingsResponse> {
    this.pageSize = params.pageSize ?? DEFAULT_PAGE_SIZE;

    return {};
  }

  public async setFilters(request: SetFiltersRequest<any>): Promise<{} | undefined> {
    return;
  }

  private request(request: GetSummaryRequest<any> | GetRowsRequest<any, any>): Promise<any> {
    request.pageSize = this.pageSize;
    request.extraParams.queryExecutionId = (this.queryExecution as QueryExecution)._id;

    return this.dependencies.api.clients.LiveSearchResults.readRecords(request, getRequestDefaultOptions());
  }
}
